import React from 'react'
import styles from './index.module.scss'
import UbfLogo from '../../assets/ubf-logo-int.svg'
import PhoneIcon from '../../assets/call.svg'
import LocationIcon from '../../assets/location.svg'
import EmailIcon from '../../assets/sms.svg'
import TwitterIcon from '../../assets/twitter.svg'
import FacebookIcon from '../../assets/facebook.svg'
import InstagramIcon from '../../assets/instagram.svg'
import YoutubeIcon from '../../assets/youtube.svg'
import TiktokIcon from '../../assets/tiktok.svg'
import SpotifyIcon from '../../assets/spotify.svg'
import TelegramIcon from '../../assets/telegram.svg'

const Footer = () => {
    return (
        <footer id="contact">
            <div className={styles.container}>
                <div className={styles.footer_content}>
                    <div className={styles.footer_logo}>
                        <img src={UbfLogo} alt='ubf logo' />
                        <p>UBF Nigeria HQ.</p>
                    </div>
                    <div className={styles.contact}>
                        <h5>Contact Us</h5>
                        <div className={styles.contact_info}>
                            <div className={styles.contact_item}>
                                <img src={PhoneIcon} alt='phone icon' />
                                <p>0807 060 2299</p>
                            </div>
                            <div className={styles.contact_item}>
                                <img src={LocationIcon} alt='location icon' />
                                <p>No 6, Zansi Close, Onike-Iwaya Road</p>
                            </div>
                            <div className={styles.contact_item}>
                                <img src={EmailIcon} alt='email icon' />
                                <a href="mailto:nigeriaubf@gmail.com">nigeriaubf@gmail.com</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.footer_bottom}>
                    <p>&copy; 2021 UBF Nigeria. All Rights Reserved</p>
                    <div className={styles.footer_socials}>
                        <a href='https://x.com/NigeriaUbf' target='_blank'><img src={TwitterIcon} alt='twitter icon' /></a>
                        <a href='https://web.facebook.com/UBFUnilag' target='_blank'><img src={FacebookIcon} alt='facebook icon' /></a>
                        <a href='https://www.instagram.com/ubfnigeria/' target='_blank'><img src={InstagramIcon} alt='instagram icon' /></a>
                        <a href='https://www.youtube.com/@ubfnigeria' target='_blank'><img src={YoutubeIcon} alt='youtube icon' /></a>
                        <a href='https://www.tiktok.com/@ubf_nigeria?lang=en' target='_blank'><img src={TiktokIcon} alt='tiktok icon' /></a>
                        <a href='https://open.spotify.com/show/0tZOb8boeX30JgHAUY3SZZ?si=IHDa118RReewie_Mop6fPA' target='_blank'><img src={SpotifyIcon} alt='spotify icon' /></a>
                        <a href='https://t.me/ubfnigeria' target='_blank'><img src={TelegramIcon} alt='telegram icon' /></a>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer